import { createSelector } from 'reselect';

import { GlobalState } from '../../reducers';
import { FetchFilesArguments } from './actions';

const filesStateSelector = (state: GlobalState) => state.apps.appManagement.files;

const filesSelector = createSelector([
  filesStateSelector,
],
(filesState) => ({
  currentPage: filesState.currentPage,
  files: filesState.items,
  groupId: filesState.groupId,
  hasError: filesState.hasError,
  isLoading: filesState.isLoading,
  itemsPerPage: filesState.itemsPerPage,
  kind: filesState.kind,
  totalItems: filesState.totalItems,
}));

const fetchFilesArgumentsSelector = createSelector([
  filesStateSelector,
],
(filesState): FetchFilesArguments => ({
  entriesPerPage: filesState.itemsPerPage,
  groupId: filesState.groupId,
  paginationPage: filesState.currentPage,
}));

export default {
  fetchFilesArgumentsSelector,
  filesSelector,
};
